import authModalLoader from '../src/utils/AuthModalLoader';

export default authModalLoader;
